<div class="container">
  <h2>Bjud in/Rekrytera</h2>
  <app-invitation-form></app-invitation-form>

  <div *ngIf="invitations | async as loadedInvitations">
    <app-invitation-list [invitations]="loadedInvitations"></app-invitation-list>

  </div>
</div>
